import React from "react"

import PopupMenuButton from "../../popup-menu-button/popup-menu-button"
import PopoverMenuCustomPopoverOptionButton from "./option-button"

type Props = {

    option              : {
        icon?                   : string
        label?                  : string
        popoverClass?           : string
        popoverContentClass?    : string
        menuComponent           : any
        disabled?               : boolean
        onClick              : callback
    }
    menuParams?         : any
    disabled?           : boolean

    onTogglePopover?    : func
}

export default function PopoverMenuOptionWithCustomPopover(props: Props) {
    return <PopupMenuButton popoverClass                = {Classes("popover-option-custom", props.option.popoverClass)}
                            popoverContentClass         = {props.option.popoverContentClass}
                            attachment                  = "top left"
                            targetAttachment            = "top right"
                            offset                      = "0 0"
                            attachmentType              = "vertical"
                            arrowsVersion               = {2}
                            outsideClickIgnoreClasses   = {["color-with-icon"]}
                            btnComponent                = {PopoverMenuCustomPopoverOptionButton}
                            menuComponent               = {props.option.menuComponent}
                            menuParams                  = {_.assign(props.menuParams, {
                                option: props.option
                            })}
                            disabled                    = {props.disabled || props.option.disabled}
                            clickOutsideDelay           = {100}
                            onTogglePopover             = {props.onTogglePopover}/>
}
